import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

export default function knockoutCriteriaReducer(state = initialState.currentOffer.partnerKnockoutCriteria, action) {
  switch (action.type) {
    case types.LOAD_OFFER_PARTNER_KNOCKOUT_CRITERIA_SUCCESS: {
      const partnerId = action.payload.partnerId;
      const knockoutCriteria = {
        ...state.knockoutCriteria,
        [partnerId]: {
          partnerId,
          isLoaded: true
        }
      };

      return {
        ...state,
        knockoutCriteria: knockoutCriteria
      };
    }

    case eventTypes.OFFER_PARTNER_KNOCKOUT_CRITERIA_INVALIDATED:
    case eventTypes.OFFER_PARTNER_KNOCKOUT_CRITERIA_EXECUTED: {
      const { partnerId } = action.event.eventBody;
      const knockoutCriteria = {
        ...state.knockoutCriteria,
        [partnerId]: {
          ...state.knockoutCriteria[partnerId],
          isLoaded: false
        }
      };
      return {
        ...state,
        knockoutCriteria: knockoutCriteria
      };
    }

    default:
      return state;
  }
}
